import * as React from 'react';
import { appStore } from '../../app/AppStore';
import { Messages } from '../../codegen/Localize';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';
import { editFlow } from '../actions/EditFlowReduxAction';
import { DraftBannerAction, DraftBanner } from '../../drafts/components/DraftBanner';
import { imgPath } from '../../common/utilities/ImgUrl';

export type FlowDraftBannerProps = {
  readonly flow: ISpaceItemDetailInfo<'flow'>;
};

export function FlowDraftBanner(props: FlowDraftBannerProps): JSX.Element {
  if (!props.flow || !props.flow.flowDraft) {
    return null;
  }

  const handleEditFlow = () => {
    if (props?.flow) {
      appStore.dispatch(editFlow(props.flow));
    }
  };

  const draftBannerActions: DraftBannerAction[] = [];
  draftBannerActions.push({
    label: Messages.continueEditing(),
    handleAction: handleEditFlow,
    iconPath: imgPath('pencil_14px_small.svg')
  });

  return (
    <DraftBanner
      lastEditDate={props.flow.flowDraft.lastUpdatedAt}
      draftBannerActions={draftBannerActions}
      contentTypeName={Messages.lastEditedFlow()}
    />
  );
}